import { render } from "./ControlAccesoModulos.vue?vue&type=template&id=4646ec34&scoped=true"
import script from "./ControlAccesoModulos.vue?vue&type=script&lang=js"
export * from "./ControlAccesoModulos.vue?vue&type=script&lang=js"

import "./ControlAccesoModulos.vue?vue&type=style&index=0&id=4646ec34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4646ec34"]])

export default __exports__